// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3ZPK0","legacyBtn":"MutateMid_legacyBtn__-OqdP"};